'use strict';

angular.module('dekky.forms.themes.far')
.run(function($templateCache) {
	$templateCache.put('/dekky.forms/themes/far/fields/collection.html',
		'<div ng-init="model = model || []" ng-model="model">' +
			'<div repeat-collection class="panel panel-default">' +
				'<div class="panel-body">' +
					'<form-row ng-repeat="(key, itemField) in field.childForm.$fields" ng-model-options="{ index: $index }" ng-model="item[key]" field="itemField"></form-row>' +
					'<div class="row">' +
						'<div class="col-sm-12 text-right">' +
							'<p><button class="btn btn-danger btn-sm" type="button" ng-click="field.doDelete(item, model, $index)"><i class="fa fa-trash-o"></i> {{ field.buttons.remove }}</button></p>' +
						'</div>' +
					'</div>' +
				'</div>' +
			'</div>' +

			'<div class="row">' +
				'<div class="col-sm-12">' +
					'<p><button class="btn btn-default btn-sm btn-success" type="button" ng-click="field.addItem(model)"><i class="fa fa-plus"></i> {{ field.buttons.add }}</button></p>' +
				'</div>' +
			'</div>' +
		'</div>'
	);
});